import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const DeleteCategoryDialog = ({ openDeleteDialog, handleCloseDeleteDialog, handleConfirmDelete }) => (
<>
      {/* Dialog for delete confirmation */}
      <Dialog
        sx={{
          zIndex: 9,
          "& .MuiDialog-container .MuiPaper-elevation": {
            borderRadius: "8px",
            width: "380px",
          },
        }}
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
      >
        <DialogTitle
          sx={{
            padding: "30px 16px 0",
            textAlign: "center",
            fontWeight: 700,
          }}
        >
          Confirm Deletion
        </DialogTitle>
        <DialogContent sx={{ padding: "0 16px 20px" }}>
          <Typography sx={{ textAlign: "center", color: "#666" }}>
            Are you sure you want to delete this category?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "0 16px 20px" }}>
          <Button
            onClick={handleCloseDeleteDialog}
            sx={{
              border: "1px solid #888",
              color: "#888",
              borderRadius: "6px",
              fontSize: "14px",
              "&:hover": {
                backgroundColor: "#b9b9b9",
                color: "#222",
                borderColor: "#b9b9b9",
              },
            }}
          >
            No
          </Button>
          <Button
            onClick={handleConfirmDelete}
            sx={{
              backgroundColor: "#142C5C",
              color: "#fff",
              borderColor: "#0f2247",
              "&:hover": {
                backgroundColor: "#0f2247",
              },
              borderRadius: "6px",
              fontSize: {
                xs: "12px",
                sm: "13px",
                md: "13px",
                lg: "14px",
                xl: "14px",
              },
              height: "40px",
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
</>
);

export default DeleteCategoryDialog;
